import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AdminChallengeContent, Challenge, ChallengeType } from '../../services/models/challenges.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { accordionTop } from '../../../_shared/animations/accordion-top';

@Component({
  selector: 'app-challenges-history-card',
  templateUrl: './challenges-history-card.component.html',
  styleUrls: ['./challenges-history-card.component.scss'],
  animations: [accordionTop],
})
export class ChallengesHistoryCardComponent implements OnInit, OnDestroy {
  private breakpointSubscription!: Subscription;

  expanded: boolean = false;

  @Input() challenge!: Challenge<AdminChallengeContent>;

  constructor(
    private readonly breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    this.breakpointSubscription = this.breakpointObserver.observe('(max-width: 992px)').subscribe(({  matches }) => {
      // For resolutions > 992px always show challenge description
      this.expanded = !matches;
    });
  }

  ngOnDestroy() {
    this.breakpointSubscription.unsubscribe();
  }

  getChallengeDescriptionLabel(): string {
    if (this.challenge.type === ChallengeType.CHECKOUT_TITLES_CHALLENGE) {
      return 'challenges.targetCheckoutTitlesChallenge';
    }

    if (this.challenge.type === ChallengeType.TITLES_READ_CHALLENGE) {
      return 'challenges.targetTitlesReadChallenge';
    }

    if (this.challenge.type === ChallengeType.READING_TIME_CHALLENGE) {
      return 'challenges.targetReadingChallenge';
    }

    return '';
  }

  toggleDescription() {
    this.expanded = !this.expanded;
  }
}
